import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const EXTERNALLY_OWNED_OPTIONS = [
  { value: 'true', label: 'True', limit: 1 },
  { value: 'false', label: 'False', limit: 1 },
];

export const externallyOwnedDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.EXTERNALLY_OWNED,
    name: 'Externally Owned',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
});
